import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import EntitySelect from '../entity-select/entity-select.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';

@Component({
  name: 'bpc-calendar-discipline-filter',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-entity-select': EntitySelect,
  },
})
export default class CalendarDisciplineFilter extends mixins(AbstractField) {
  @Prop([String, Number]) readonly value: string | number;
  @Prop(Array) readonly filters: any[];
  public loading = false;

  public options: object[] = [];

  public modelSelect = null;
  public modelRadioButtons = null;

  get path(): string {
    return this.$bpcApiRouteHelper.getEntityPath('disciplines');
  }

  get model(): string | number {
    return this.value;
  }
  set model(val: string | number) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
    this.setSubmodel(val);
  }
  onChange(val) {
    if (val) {
      this.model = val;
    } else {
      this.model = null;
    }
  }
  onEnterKey() {
    this.$emit('enter-key');
  }

  mounted() {
    this.getOptions();
  }
  // updated () { }

  // destroyed () { }

  public getOptions(): void {
    this.$bpcApi.get(this.path, { params: { favorite: 1 } }).subscribe(
      (res: BPCGenericApiResponse) => {
        this.options = this.processOptions(res.data);
        this.setSubmodel(this.model);
      },
      error => {
        console.log(error);
      },
      () => {
        this.loading = false;
      },
    );
  }

  public processOptions(options) {
    return options.map(option => {
      return { text: option.code, value: option.id };
    });
  }
  public setSubmodel(val) {
    if (val) {
      const exists = this.options.filter(option => {
        return option['value'] == val;
      });
      if (exists.length) {
        this.modelRadioButtons = val;
        this.modelSelect = null;
      } else {
        this.modelSelect = val;
        this.modelRadioButtons = null;
      }
    } else {
      this.modelSelect = null;
      this.modelRadioButtons = null;
    }
  }
}
